import { useState } from 'react';

export interface Transformable {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  origin: [number, number];
  zIndex: number;
}

// Generic type for custom elements that extend Transformable
export type TransformableElement<T = {}> = Transformable & T;

export interface DragState {
  isDragging: boolean;
  elementId: string | null;
  startX: number;
  startY: number;
  offsetX: number;
  offsetY: number;
}

export interface ResizeState {
  isResizing: boolean;
  elementId: string | null;
  handle: string;
  startWidth: number;
  startHeight: number;
  startX: number;
  startY: number;
}

export interface RotateState {
  isRotating: boolean;
  elementId: string | null;
  startAngle: number;
  centerX: number;
  centerY: number;
}

export interface SelectionBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface Transformation {
  id: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  rotation?: number;
  deltaX?: number;
  deltaY?: number;
  deltaWidth?: number;
  deltaHeight?: number;
  deltaRotation?: number;
}

export const useTransformable = () => {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [dragState, setDragState] = useState<DragState>({ isDragging: false, elementId: null, startX: 0, startY: 0, offsetX: 0, offsetY: 0 });
  const [resizeState, setResizeState] = useState<ResizeState>({ isResizing: false, elementId: null, handle: '', startWidth: 0, startHeight: 0, startX: 0, startY: 0 });
  const [rotateState, setRotateState] = useState<RotateState>({ isRotating: false, elementId: null, startAngle: 0, centerX: 0, centerY: 0 });
  const [selecting, setSelecting] = useState(false);
  const [selection, setSelection] = useState<SelectionBox | null>(null);
  const [selectionStart, setSelectionStart] = useState<{ x: number; y: number } | null>(null);

  return {
    // State
    selected,
    setSelected,
    dragState,
    resizeState,
    rotateState,
    selecting,
    selection,
    selectionStart,
    
    // Setters
    setDragState,
    setResizeState,
    setRotateState,
    setSelecting,
    setSelection,
    setSelectionStart,
  };
};
